import React, { useEffect, useState } from 'react';
import { toast } from "react-toastify";
import '../leadingPage/leadPage.css';
import { useSelector } from 'react-redux';
import { apiData } from '../../../actions';
import OwlCarousel from 'react-owl-carousel';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import SpcificPageModal from '../../Modals/SpcificPageModal';
import axios from "axios";
// import { useLocation } from 'react-router-dom'; 

const LeadPage = () => {
    const place = useSelector(state => state.place);
    const [hotelUrl, setHotelUrl] = useState('');
    const navigate = useNavigate();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [travelerType, setTravelerType] = useState("");
    const [errors, setErrors] = useState({});
    const [tour, setTour] = useState([]);
    const [CoolDeals, setCoolDeals] = useState([]);
    // console.log("CoolDeals",CoolDeals);
    const [beautifulCity, setBeautifulCity] = useState("");
    const [loader, setLoader] = useState(false);
    const [message, setMessage] = useState('');
    const [leadPages, setLeadPages] = useState('');
    const [loading, setLoading] = useState(false);

    const validCities = [
        { name: 'chicago' },
        { name: 'seattle' },
        { name: 'boston' },
        { name: 'orlando' },
        { name: 'miami' }
    ];

    const [specificModal, setSpecificModal] = useState(false);

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const handleSubmit = async (e) => {
        e.preventDefault();

        let formErrors = {};

        // Name Validation
        if (!name.trim()) {
            formErrors.name = 'Name is required';
        } else if (name.length < 2) {
            formErrors.name = 'Name should be at least 2 characters';
        }

        // Email Validation
        if (!email.trim()) {
            formErrors.email = 'Email is required';
        } else if (!email.includes('@')) {
            formErrors.email = 'Email must contain @';
        } else if (email.includes('..')) {
            formErrors.email = 'Email cannot contain consecutive dots';
        } else if (!emailRegex.test(email)) {
            formErrors.email = 'Please enter a valid email';
        }

        // Traveler Type Validation
        if (!travelerType.trim()) {
            formErrors.travelerType = 'Traveler Type is required';
        }

        setErrors(formErrors);

        // If no errors
        if (Object.keys(formErrors).length === 0) {
            setLoading(true); // Start loader

            try {
                const response = await fetch(`https://backend.mysittivacations.com/api/user-subscription?email=${encodeURIComponent(email)}&firstName=${encodeURIComponent(name)}&city=${encodeURIComponent(place)}&travelerType=${encodeURIComponent(travelerType)}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                const data = await response.json();

                if (!response.ok) {
                    throw new Error(data.message || 'Failed to submit form');
                }

                toast.success(data.message);
                setName('');
                setEmail('');
                setTravelerType('');
            } catch (error) {
                console.error('Submission error:', error);
                toast.error(error.message || 'Submission failed');
            } finally {
                setLoading(false); // Stop loader
            }
        } else {
            console.warn("Validation Errors:", formErrors);
        }
    };


    const handleNameChange = (e) => {
        setName(e.target.value);

        if (errors.name) {
            setErrors((prevErrors) => ({ ...prevErrors, name: '' }));
        }
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);

        const emailPattern = /\S+@\S+\.\S+/;

        if (emailPattern.test(value)) {
            setErrors((prevErrors) => ({ ...prevErrors, email: '' }));
        } else {
            setErrors((prevErrors) => ({ ...prevErrors, email: 'Email address is invalid' }));
        }
    };
    const handleTravelerTypeChange = (e) => {
        setTravelerType(e.target.value);
        if (errors.travelerType) {
            setErrors((prevErrors) => ({ ...prevErrors, travelerType: '' }));
        }
    };
    const getTourDeals = async () => {
        let payload = {
            city: place,
            limit: 4,
        };
        try {
            let apiRes = await apiData.get_Tour(payload);
            console.log("Tour API Response:", apiRes);

            if (apiRes?.status >= 200 && apiRes?.status <= 399) {
                const tourList = apiRes?.data?.data?.data?.travelExperienceProducts?.resultList;
                setTour(tourList || []);
            } else {
                setTour([]);
            }
        } catch (err) {
            console.error("Error fetching tour data:", err);
            setTour([]);
        }
    };
    const Beautiful_city = async () => {
        let payload = {
            city: place,
        };
        let apiRes = await apiData.getBeautifulCity(payload);
        if (apiRes?.status >= 200 && apiRes?.status <= 399) {
            setBeautifulCity(apiRes?.data?.data);
        }
    };
    const CoolFlightDeals = async () => {
        setLoader(true);
        let apiRes = await apiData.coolFlightDeals();
        if (apiRes?.status >= 200 && apiRes?.status <= 399) {
            setCoolDeals(apiRes?.data?.data);
            setLoader(false);
        }
        if (apiRes?.status >= 400 && apiRes?.status <= 500) {
            console.log("error");
        }
    };
    // const leadingPage = async () => {
    //     setLoader(true);
    //     let payload = {
    //         city: place,
    //     };
    //     let apiRes = await apiData.leadingPages(payload);
    //     if (apiRes?.status >= 200 && apiRes?.status <= 399) {
    //         setLeadPages(apiRes?.data?.data[0]);
    //         setLoader(false);
    //     }
    // }

    // const [leadPages, setLeadPages] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {

        setIsLoading(true);

        const fetchData = async () => {
            try {

                const timeout = setTimeout(() => {
                    setIsLoading(true);
                }, 3000);

                let payload = {
                    city: place,
                };
                let apiRes = await apiData.leadingPages(payload);
                if (apiRes?.status >= 200 && apiRes?.status <= 399) {
                    setLeadPages(apiRes?.data?.data[0]);
                    setLoader(false);
                }
                clearTimeout(timeout);
                setIsLoading(false);
            } catch (error) {
                console.error("Error fetching data:", error);
                setIsLoading(false);
            }
        };
        CoolFlightDeals();
        fetchData();
    }, [place]);

    const loadCityScript = (beautifulCity) => {
        const tourElement = document.getElementById("tour");

        if (tourElement) {
            // Clear any existing script in the tour element
            tourElement.innerHTML = "";

            let script = document.createElement('script');

            if (beautifulCity) {
                const scriptUrl = beautifulCity.split('"')[1];
                script.src = scriptUrl;
                script.async = true;
                script.onload = () => {
                    setLoader(false);
                };

                // Append the script to the 'tour' div
                tourElement.appendChild(script);
            }
        }
    };
    const getFlightCode = (city) => {
        const cityCodes = {
            'chicago': 'CHI', 'los-angeles': 'LAX', 'san-francisco': 'SFO', 'miami': 'MIA', 'las-vegas': 'LAS', 'boston': 'BOS', 'seattle': 'SEA',
            'dallas': 'DFW', 'atlanta': 'ATL',
            'orlando': 'MCO', 'washington-dc': 'WAS',
            'santiago': 'SCL', 'philadelphia': 'PHL', 'san-diego': 'SAN', 'new-york': 'NYC',
            'new-orleans': 'MSY', 'denver': 'DEN', 'phoenix': 'PHX', 'austin': 'AUS', 'charlotte': 'CLT',
            'salt-lake-city': 'SLC', 'san-antonio': 'SAT', 'minneapolis': 'MSP', 'savannah': 'SAV', 'honolulu': 'HNL'
            // Add more mappings as needed
        };

        return cityCodes[city] || 'UNKNOWN';
    };
    const normalizeCityName = (city) => {
        return city
            .replace(/[.,]/g, '')  // Remove periods and commas
            .replace(/\s+/g, '-')  // Replace spaces with hyphens
            .toLowerCase();        // Convert to lowercase

    };
    const { city } = useParams();
    const cityEncoded = encodeURIComponent(city);

    const normalizedCity = normalizeCityName(city);
    const flightCode = getFlightCode(normalizedCity);
    useEffect(() => {
        setLoader(true);
        loadCityScript(beautifulCity);
        getTourDeals();
    }, [place, beautifulCity]);

    useEffect(() => {
        if (place) {
            Beautiful_city();
        }

    }, [place]);

    // useEffect(() => {

    //     CoolFlightDeals();
    //     let script = document.createElement("script");
    //     script.id = "main50";
    //     script.src = "https://embed.lpcontent.net/leadboxes/current/embed.js";

    //     document?.body?.appendChild(script);

    //     let script1 = document.createElement("script");
    //     script1.id = "main55";
    //     script1.innerHTML =
    //         "window.addEventListener('LPLeadboxesReady',function(){LPLeadboxes.addDelayedLeadbox('FNgWxcgxhAQZLSdys5HNt5',{delay:'0s',views:0,dontShowFor:'0d',domain:'mysittivacations.lpages.co'});})";

    //     document?.body?.appendChild(script1);
    //     return () => {
    //         document?.getElementById("main55")?.remove();
    //         document?.querySelector(".lp-popup__iframe-wrapper")?.remove();
    //     };

    // }, []);

    useEffect(() => {
        if (!city) {
            setMessage('City not found. Please provide a valid city.');
        } else {
            setMessage('');
        }
    }, [city]);

    var settings1 = {
        items: 4,
        loop: true,
        autoplay: true,
        autoplayTimeout: 2000,
        autoplayHoverPause: true,
        nav: true,
        dots: false,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 2
            },
            991: {
                items: 4
            }
        }
    };
    const responsive321 = {
        items: 4,
        loop: true,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        nav: true,
        dots: false,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 2
            },
            992: {
                items: 4
            }
        }
    };
    const location = useLocation();

    useEffect(() => {
        const encodedCity = encodeURIComponent(city);
        if (location.pathname === `/experiences/${encodedCity.toLowerCase()}`) {
            setSpecificModal(true);
        }
    }, [location, city]);

    useEffect(() => {
        if (place) {
            axios
                .get(`${process.env.REACT_APP_BASE_URL}hotel-url?city=${place}`, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                .then(
                    (response) => {
                        const cityCode = response?.data?.data?.[0]?.city_id_code;
                        if (cityCode) setHotelUrl(cityCode);
                    },
                    (error) => {
                        console.log(error);
                    }
                );
        }
    }, [place]);

    return (

        <div>
            <section className="banner-main">
                <div className="banner-img">
                    {isLoading ? (
                        <div className="loader"></div>
                        // <DataLoader/>
                    ) : (
                        <img loading="lazy" src={leadPages?.top_banner} alt="banner_image" />
                    )}

                </div>
                <div className="container bannermain-inner">
                    <div className="banner-contents">
                        <h1>{place ? place?.split(',')[0]?.replace(/\b\w/g, x => x?.toUpperCase()) : 'Chicago'}</h1>
                        <p>
                            {isLoading ? (
                                <div className="loader"></div>
                            ) : (
                                <p>{leadPages?.top_description}</p>
                            )}
                            {/* <span><img src="/imagesNew/airplane-sky_1308-31202-.png" alt="" /></span> */}
                        </p>
                    </div>
                </div>
            </section>

            <section className="choose-options-sec">
                {/* <div className="bgsec-img"><img src="/imagesNew/2147647103.jpg" alt="" /></div> */}
                <div className="container choose-sec-inner">
                    <div className="option-boxes">
                        <a className="box-options" href={hotelUrl}>
                            <div className="box-img"><img src="/imagesNew/hotel.jpg" alt="hotel" /></div>
                            <h5>HOTELS</h5>
                        </a>

                        <a className="box-options" href={`https://travel.mysittivacations.com/flights/IXC1009${flightCode}12091`}>
                            <div className="box-img"><img src="/imagesNew/airplane.jpg" alt="airplane" /></div>
                            <h5>FLIGHTS</h5>
                        </a>

                        <a className="box-options" href={`/car-rental/${cityEncoded}`}>
                            <div className="box-img"><img src="/imagesNew/car-rental.jpg" alt="car-rental" /></div>
                            <h5>CAR RENTALS</h5>
                        </a>

                        <a className="box-options" href={`/restaurant/${cityEncoded}`}>
                            <div className="box-img"><img src="/imagesNew/restaurant.jpg" alt="restaurant" /></div>
                            <h5>RESTAURANTS</h5>
                        </a>

                        <a className="box-options" href="/blog">
                            <div className="box-img"><img src="/imagesNew/blog.jpg" alt="blog" /></div>
                            <h5>BLOGS</h5>
                        </a>
                    </div>
                </div>
            </section>

            <section className="discover-sec">
                <div className="container discover-inner">
                    <div className="disc-left">
                        <h2>Discover Authentic <br />{place?.split(',')[0]?.replace(/\b\w/g, x => x?.toUpperCase())} Experiences</h2>
                        <p>{leadPages?.experiences_description}</p>
                    </div>
                    <div className="disc-right">
                        <div className="disc-right-img"><img loading="lazy" src={leadPages?.experiences_image} alt="" /></div>
                    </div>
                </div>
            </section>

            <section className="dis-cuba-sec">
                <div className="dis-cuba-img">
                    <img loading="lazy" src={leadPages?.descover_image} alt="cuba images" />
                </div>
                <div className="container dis-cuba-inner">
                    <div className="cuba-contentss">
                        <h2>Discover {place?.split(',')[0]?.replace(/\b\w/g, x => x?.toUpperCase())} :</h2>
                        <div className="para-cnts">
                            <p dangerouslySetInnerHTML={{ __html: leadPages?.descover_description }}></p>
                        </div>
                    </div>
                </div>
            </section>


            <section className="mysittivacation-sec">
                <div className="container mysittivacation-inner">
                    <h2>Why choose MySittiVacation for <br />
                        your solo journey to {place?.split(',')[0]?.replace(/\b\w/g, x => x?.toUpperCase())}?</h2>
                    <div className="mysiitivc-cnts">
                        <p dangerouslySetInnerHTML={{ __html: leadPages?.solo_description }}></p>

                    </div>
                </div>
            </section>

            <section className="tour-packages-sec">
                <div className="container tour-pkg-inner">
                    <div className="col-md-12 col-lg-12">
                        <div className="slider-sec">
                            <div data-aos="zoom-in-left" className="slider-header">
                                <h2>Flight Specials</h2>

                            </div>
                            <p data-aos="zoom-in-right">Hey there! Picture this – vibing in the hustle of New York City, soaking up the starry vibes in Los Angeles, exploring architectural wonders in Chicago, or just chilling on the sunny beaches of Miami. Our Flight Specials make it all possible! Score unbeatable airfare deals, turn your travel dreams into reality, and let's make some epic memories together. Come on, let's take flight and create unforgettable experiences! ✈️</p>
                            <div data-aos="zoom-in-left" className="slider-main">
                                {place ? (
                                    CoolDeals && CoolDeals.length > 0 ? (
                                        <OwlCarousel
                                            className="owl-carousel owl-theme"
                                            {...responsive321}
                                        >
                                            {CoolDeals.map((deal, index) => (
                                                <div key={index} className="testimonial-block product">
                                                    <a href={deal.url} target="_blank" rel="noreferrer">
                                                        <div className="discount-block">
                                                            <img loading="lazy" src={deal.image_url} alt="Deal" />
                                                            <h3>{deal.title}</h3>
                                                        </div>
                                                    </a>
                                                </div>
                                            ))}
                                        </OwlCarousel>
                                    ) : (
                                        <p>Oops! No Deals Available for {place.replace(/\b\w/g, x => x?.toUpperCase())}</p>
                                    )
                                ) : (
                                    <p>Please enter a city in the URL to see the available deals.</p>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-12 col-lg-12">
                        <div className="slider-main">
                            <div className="slider-sec">
                                <h2>
                                    {place
                                        ? `See Beautiful ${place?.split(',')[0]?.replace(/\b\w/g, x => x?.toUpperCase())}`
                                        : 'See Beautiful Destinations'}
                                </h2>
                                <p>
                                    Get set for an awesome vacation! Explore sightseeing tours, bus excursions, and exclusive passes. Uncover hidden gems, create memorable moments, and elevate your trip. Time to make the most of it – book your tours now and let the adventure begin!
                                </p>
                            </div>
                            <div id="tour"></div>
                            {/* <div className="view-tag clickable">
        <a id="beautifulBtn" ref={BtnMore} onClick={handleSeeAllClick} className='m-4'>
            See All
        </a>
    </div> */}
                        </div>

                    </div>
                </div>
            </section>

            <section className="tour-packages-sec inclusive-sec">
                <div className="container tour-pkg-inner">
                    <div className="flight-sec exitment-sec tour-slider">
                        <div className="slider-sec">
                            <h3>
                                {place
                                    ? `${place?.split(',')[0]?.replace(/\b\w/g, x => x?.toUpperCase())} Tours`
                                    : 'Tours'}
                            </h3>
                            <p>Save big on thrilling tours and sightseeing adventures! We've found Groupon deals for helicopter rides, bus tours, and more. Experience the best while keeping your wallet happy.</p>

                            <div className="slider-main slider-section discount-section stay-sec comn-div">
                                <div className="container">
                                    <div className="row">
                                        <div className="cityTour col-12 col-md-12 col-lg-12">
                                            {place ? (
                                                tour && tour.length > 0 ? (
                                                    <OwlCarousel {...settings1}>
                                                        {tour.map((ele, index) => (
                                                            <div
                                                                key={ele?.id || index}
                                                                data-aos="zoom-in-right"
                                                                className="slider-block"
                                                            >
                                                                <a href={ele?.link} target="_blank" rel="noreferrer">
                                                                    <img loading="lazy" src={ele?.imageLink} alt="Tours" />
                                                                    <div className="slider-content CityTourePriceDec">
                                                                        <div className="slider-content-inner">
                                                                            <h3>
                                                                                {ele?.title.length >= 20
                                                                                    ? `${ele?.title.slice(0, 20)}...`
                                                                                    : ele?.title}
                                                                            </h3>
                                                                            <p>{ele?.description.slice(0, 30)}..</p>
                                                                        </div>
                                                                        <div className="discount-action hotels purple-bg city-price">
                                                                            <div className="review-sec">
                                                                                <p>
                                                                                    {ele?.price?.amount !== ele?.salePrice?.amount ? (
                                                                                        <>
                                                                                            <span className="old-price">${ele?.price?.amount}</span>{" "}
                                                                                            <span className="new-price">${ele?.salePrice?.amount}</span>{" "}
                                                                                            <span className="dis-percent">

                                                                                                {(() => {
                                                                                                    const originalPrice = Number(ele?.price?.amount);
                                                                                                    const salePrice = Number(ele?.salePrice?.amount);
                                                                                                    const discount =
                                                                                                        originalPrice && salePrice
                                                                                                            ? Math.max(0, Math.round(((originalPrice - salePrice) / originalPrice) * 100))
                                                                                                            : 0;
                                                                                                    return `${discount}%`;
                                                                                                })()}
                                                                                            </span>
                                                                                        </>
                                                                                    ) : (
                                                                                        <span className="new-price">${ele?.salePrice?.amount}</span>
                                                                                    )}
                                                                                </p>
                                                                                <a className="siti-btn">Book Now</a>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        ))}
                                                    </OwlCarousel>
                                                ) : (
                                                    <p>Oops! No Data Available {`For ${place.replace(/\b\w/g, (x) => x.toUpperCase())}`}</p>
                                                )
                                            ) : (
                                                <p>Please enter a city in the URL to see the available data.</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>

            <section className="adventure-mxcec">
                <div className="advnt-img">
                    <img src="/imagesNew/bgflowers.jpg" alt="" />
                </div>
                <div className="container advn-mxc-inner">

                    <div className="advn-mxcolmn">
                        <div className="advn-left">
                            <h2>
                                Your solo female adventure in {place?.split(',')[0]?.replace(/\b\w/g, x => x?.toUpperCase())} {""}
                                awaits you.</h2>
                            <p>Your solo adventure in {place?.split(',')[0]?.replace(/\b\w/g, x => x?.toUpperCase())} awaits you! Dive into turquoise Start Planning
                                waters, explore vibrant streets, and dance under the stars. Ready
                                for an unforgettable journey?</p>
                        </div>
                        <div className="advn-right">
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput2" className="form-label">Name</label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                        id="exampleFormControlInput2"
                                        placeholder="First Name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                    {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="email" className="form-label">Email</label>
                                    <input
                                        type="email"
                                        className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                        id="email"
                                        placeholder="Email Address"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                    {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="travelerType" className="form-label">Traveler Type</label>
                                    <select
                                        className={`form-control ${errors.travelerType ? 'is-invalid' : ''}`}
                                        id="travelerType"
                                        value={travelerType}
                                        onChange={(e) => setTravelerType(e.target.value)}
                                    >
                                        <option value="">Select Type</option>
                                        <option value="LGBTQ">LGBTQ</option>
                                        <option value="Solo Female">Solo Female</option>
                                        <option value="General">General</option>
                                        <option value="Family">Family</option>
                                        <option value="Couple">Couple</option>
                                    </select>
                                    {errors.travelerType && <div className="invalid-feedback">{errors.travelerType}</div>}
                                </div>

                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={loading}
                                >
                                    {loading ? 'Submitting...' : 'Start Planning'}
                                </button>
                            </form>

                        </div>

                    </div>


                </div>
            </section>


            <section className="faq-sec">
                <div className="container">
                    <h2>FAQs</h2>
                    <div className="faq-inner">
                        <p dangerouslySetInnerHTML={{ __html: leadPages?.faq }}></p>

                    </div>
                    <>
                        {specificModal && (
                            <SpcificPageModal
                                specificModal={specificModal}
                                setSpecificModal={setSpecificModal}
                            />
                        )}
                    </>
                </div>
            </section>

        </div>

    )
}

export default LeadPage;